import React, { useEffect } from 'react'
import AboutHero from '../../components/About/AboutHero'
import WhoWeAre from '../../components/About/WhoWeAre'
import Partners from '../../components/About/Partners'
import ContactCTA from '../../components/About/ContactCTA'
import NewsletterCTA from '../../components/About/NewsletterCTA'
import Footer from '../../components/landing/Footer'
import GuestNavbar from '../../components/navigations/GuestNavbar'

const About = () => {
  useEffect(()=>{
    window.scrollTo(0,0);
  },[])
  
  return (
    <div>
      <GuestNavbar/>
      <AboutHero />
      <WhoWeAre />
      <Partners />
      <ContactCTA />
      <NewsletterCTA />
      <Footer />
    </div>
  )
}

export default About